import React from "react";

import Button from "@mui/material/Button";

const SignUpButton = ({ handleSetAuthenticationIsOpen }) => (
  <Button
    variant="contained"
    disableElevation
    onClick={() => {
      handleSetAuthenticationIsOpen(true, "SIGNUP");
    }}
    sx={{
      borderRadius: "9px",
      padding: "6px 18px",
      fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
      fontWeight: 600,
      fontSize: "14px",
      textTransform: "none",
      whiteSpace: "nowrap",
      boxShadow: "0 4px 12px rgba(25,118,210,0.25)",
      "&:hover": {
        boxShadow: "0 6px 16px rgba(25,118,210,0.35)",
      },
    }}
  >
    Sign up
  </Button>
);

export default SignUpButton;
